import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "../services/common.service";
import { InquiryFormComponent } from "../shared/inquiry-form/inquiry-form.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-inquiry",
  templateUrl: "./inquiry.component.html",
  styleUrls: ["./inquiry.component.scss"],
})
export class InquiryComponent implements OnInit {
  @ViewChild(InquiryFormComponent) inquiryFormComponent: InquiryFormComponent;

  loading: boolean = false;
  isMobileView: boolean = false;
  isCancelVisible: boolean = false;
  isFlexfieldEnable: boolean = false;
  showVideoConf: boolean = false;
  isMemberVisible: boolean = false;
  isCategoryVisible: boolean = false;
  isEmailFieldRequired: boolean = false;
  isSubmitted: boolean = false;
  headerData = null;
  category = null;
  members = null;
  selectedCategory: any = null;
  categoryLabelName = null;
  selectedPerson: any = null;
  flexFieldData = null;
  bookingFlexFieldDetails: any = null;
  bookingDetails = {
    category: {
      category_name: "-",
    },
    member: {
      personnel: "-",
    },
    personnelLabel: "-",
    name: "-",
    phone: "-",
    email: "-",
  };

  constructor(
    private router: Router,
    private location: Location,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
    this.headerData = this.commonService.newAppointmentData.headerData;
    this.category = this.commonService.newAppointmentData.categoryData;
    this.selectedCategory = history.state?.category_id
      ? history.state.category_id
      : null;
    if (this.category?.length) {
      this.isCategoryVisible = true;
      this.onChangeCategory();
    }
    if (!this.commonService.newAppointmentData.slug) {
      const localStorageSlug = sessionStorage.getItem("slug");
      this.commonService.newAppointmentData.slug = localStorageSlug;
      this.commonService.newAppointmentData.appointmentType = 1;
    }
    this.getMetaData();
    this.getTeamMembers();
  }

  public goBack() {
    this.location.back();
  }

  public goNext() {
    this.isSubmitted = true;
    if (!this.isValidData()) {
      return;
    }

    let flexData = this.inquiryFormComponent?.flexFieldData;
    let payloadData = {
      first_name: null,
      country_code: "91",
      phone_number: null,
      email_id: null,
      notes: null,
      tag_team_member: null,
      category_id: null,
      fields: null,
      is_option: null, // wapp option
      is_video_meeting: false,
      source: null,
    };
    payloadData.first_name = this.inquiryFormComponent.inquiryData.name;
    payloadData.phone_number =
      this.inquiryFormComponent.inquiryData.phoneNumber.toString();
    payloadData.email_id = this.inquiryFormComponent.inquiryData.email;
    payloadData.notes = this.inquiryFormComponent.inquiryData.description;
    if (this.selectedCategory) {
      payloadData.category_id = this.selectedCategory;
    }
    if (this.selectedPerson) {
      payloadData.tag_team_member = this.selectedPerson;
    }
    payloadData.source = sessionStorage.getItem("source");

    if (this.isFlexfieldEnable) {
      let tmpFlexPayload = {};
      flexData?.forEach((element: any) => {
        if (element.input_type == "Toggle") {
          if (!element.value) {
            element.value = false;
          }
        }
        let tmpData = {
          flexId: element?.field_id,
          value: element?.value,
        };
        tmpFlexPayload[tmpData.flexId] = element.value;
      });
      payloadData.fields = tmpFlexPayload;
    }

    this.bookInquiry(payloadData);

    // this.router.navigateByUrl("customer/booking-confirmation");
  }

  public onChangeCategory() {
    let categoryData = this.category?.find(
      (category: any) => this.selectedCategory == category.category_id
    );
    if (categoryData && categoryData.category_name) {
      this.bookingDetails.category = categoryData;
    }
  }

  public onChangeMember() {
    let tagTeamMember = this.members?.find(
      (member: any) => this.selectedPerson == member.manager_id
    );
    if (tagTeamMember && tagTeamMember.manager_first_name) {
      this.bookingDetails.member.personnel =
        tagTeamMember.manager_first_name +
        " " +
        tagTeamMember.manager_last_name;
    }
  }

  private bookInquiry(payload) {
    this.loading = true;
    this.commonService.bookEnquiry(payload).subscribe(
      (data: any) => {
        if (data.code === 200) {
          this.loading = false;
          this.isSubmitted = false;
          let bookingId = data.data.enquiry_id;
          sessionStorage.setItem("bookingId", bookingId);
          this.router.navigateByUrl("customer/booking-confirmation", {
            state: bookingId,
            replaceUrl: true,
          });
        }
      },
      (error: any) => {
        console.log("error", error.error);
        this.toastr.error(error.error.message);
        this.loading = false;
        this.isSubmitted = false;
      }
    );
  }

  private getMetaData() {
    this.loading = true;
    this.commonService.getAppointmentMetaData().subscribe((data: any) => {
      if (data.code === 200) {
        let res = data.data;
        let headerData = {
          outlet: res.business_outlet_name,
          business: res.business_name,
          business_logo: res.business_logo,
          is_welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.is_short_welcome_banner_text
            : res.appointment_setting_details.is_welcome_banner_text,
          welcome_banner_text: this.isMobileView
            ? res.appointment_setting_details.short_welcome_banner_text
            : res.appointment_setting_details.welcome_banner_text,
        };
        this.categoryLabelName = res.appointment_setting_details.display_name;
        this.commonService.newAppointmentData.headerData = headerData;
        this.headerData = headerData;
        headerData = null;
        this.bookingDetails.personnelLabel =
          res.appointment_setting_details.display_name;

        //setting theme color set in the appointment settings
        const primaryColor =
          res.appointment_setting_details.primary_color_theme;
        sessionStorage.setItem("theme_color", primaryColor);
        this.commonService.newAppointmentData.themeColor = primaryColor;
        document.documentElement.style.setProperty(
          "--custom-color",
          primaryColor
        );
        document.documentElement.style.setProperty(
          "--custom-color-100",
          this.commonService.convertHexToRgb(primaryColor, 0.1)
        );

        if (
          res.appointment_setting_details.consumer_booking_type?.toUpperCase() ==
          "BOTH"
        ) {
          this.isCancelVisible = true;
        }

        if (!this.category) {
          let catData = [];
          res.categories?.forEach((element: any) => {
            if (element?.category_name && element.category_name.length) {
              element.active = false;
              element.category_name = this.commonService.capitalizeString(
                element.category_name
              );
              catData.push(element);
            }
          });

          if (res.appointment_setting_details.enable_appointment_category) {
            this.category = catData;
            this.commonService.newAppointmentData.categoryData = catData;
            if (this.category?.length) {
              this.isCategoryVisible = true;
            }
          } else {
            this.category = [];
          }
        }

        if (
          res.appointment_setting_details.notification_channel?.toUpperCase() ==
          "EMAIL"
        ) {
          this.isEmailFieldRequired = true;
        } else {
          this.isEmailFieldRequired = false;
        }

        if (
          !res.appointment_setting_details.auto_assign_team_member &&
          (res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
            "BOTH" ||
            res.appointment_setting_details.tag_team_member_setting?.toUpperCase() ==
              "CONSUMER")
        ) {
          this.isMemberVisible = true;
        }

        this.isFlexfieldEnable =
          res.appointment_setting_details.enable_appointment_flex_field;

        this.flexFieldData = res.field_details;
        let tmpFlexData = [];
        this.flexFieldData.forEach((element: any) => {
          if (element.field_name) {
            if (element.input_type == "Toggle") {
              element.value = false;
            } else {
              element.value = null;
            }
            tmpFlexData.push(element);
          }
        });
        this.flexFieldData = [];
        this.flexFieldData = tmpFlexData;
        tmpFlexData = [];
        this.flexFieldData = JSON.parse(JSON.stringify(this.flexFieldData));

        // let sourcePlatform = res?.google;
        // this.showVideoConf = sourcePlatform == "connected" ? true : false;

        this.loading = false;
      }
    });
  }

  private getTeamMembers() {
    this.commonService.getTagTeamMembers().subscribe((data: any) => {
      if (data.code === 200) {
        this.members = data.data;
        if (this.members && this.members.length) {
          this.members.forEach((element) => {
            element.manager_first_name = this.commonService.capitalizeString(
              element.manager_first_name
            );
            element.manager_last_name = this.commonService.capitalizeString(
              element.manager_last_name
            );
            element.name =
              element.manager_first_name + " " + element.manager_last_name;
          });
        }
      }
    });
  }

  public isValidData() {
    let basicData = this.inquiryFormComponent?.inquiryData;
    if (basicData?.name) {
      this.bookingDetails.name = basicData.name;
    } else {
      this.bookingDetails.name = "-";
    }
    if (basicData?.email) {
      this.bookingDetails.email = basicData.email;
    } else {
      this.bookingDetails.email = "-";
    }
    if (basicData?.phoneNumber) {
      this.bookingDetails.phone = basicData.phoneNumber.toString();
    } else {
      this.bookingDetails.phone = "-";
    }

    if (this.isFlexfieldEnable && this.inquiryFormComponent?.flexFieldData) {
      this.bookingFlexFieldDetails = this.inquiryFormComponent?.flexFieldData;
      let data = [];
      data = this.commonService.deepCloneArray(
        this.inquiryFormComponent.flexFieldData
      );
      data.forEach((element: any) => {
        if (element.input_type == "Toggle") {
          if (!element.value || element.value == "false") {
            element.value = "No";
          } else {
            element.value = "Yes";
          }
        } else {
          if (!element.value) {
            element.value = "-";
          }
        }
      });
      this.bookingFlexFieldDetails = null;
      this.bookingFlexFieldDetails = data;
    }

    // if Desktop then fetch data and show on RHS section.

    if (
      this.inquiryFormComponent?.isValidInquiryData() &&
      this.inquiryFormComponent?.isValidFlexData()
    ) {
      if (
        (this.category?.length && !this.selectedCategory) ||
        (this.isMemberVisible && !this.selectedPerson)
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
